import React, { useEffect, useRef } from 'react';

import trackEvent from '@99designs/common/utils/platform/trackEvent';

interface TrackClickProps {
    event: string;
    element: string;
    payload?: Record<string, any>;
    children: React.ReactChild;
}

export default function TrackClick({ event, element, children, payload = {} }: TrackClickProps) {
    const el = useRef<HTMLElement>(null!);
    const delay = 300;

    function track() {
        trackEvent(event, { ...payload, element });
    }

    function delayNavigation(e: Event, link: HTMLAnchorElement) {
        e.preventDefault();
        e.stopPropagation();
        setTimeout(() => {
            window.location.href = link.getAttribute('href') || '';
        }, delay);
    }

    // Mimics the delay from segments trackLink
    useEffect(() => {
        const listeners: {
            link: HTMLAnchorElement;
            listener: (e: Event) => void;
        }[] = [];

        el.current.addEventListener('click', track, true);
        const links = el.current.querySelectorAll('a');
        Array.from(links).forEach(link => {
            const listener = (e: Event) => delayNavigation(e, link);
            link.addEventListener('click', listener);
            listeners.push({ link, listener });
        });

        return () => {
            el.current.removeEventListener('click', track, true);
            Array.from(listeners).forEach(({ link, listener }) => {
                link.removeEventListener('click', listener);
            });
        };
    });

    return <span ref={el}>{children}</span>;
}



// WEBPACK FOOTER //
// ./src/js/components/TrackClick.tsx